<template>
    <div class="modern-card text-center">
        <div class="welcome-header">
            <div class="typing-container mb-3">
                <span class="display-4 fw-bold" ref="typingTarget"></span>
            </div>
            <p class="lead mb-0">Wie geht es uns denn so rund um Hertha BSC?</p>
        </div>
    </div>
</template>
  
  <script>
  import Typed from 'typed.js';
  import { ref, onMounted } from 'vue';
  
  export default {
    setup() {
      const typingTarget = ref(null);
  
      onMounted(() => {
        new Typed(typingTarget.value, {
          strings: ["Berliner...", "Brandenburger...", "Herthafans,"],
          typeSpeed: 100,
          backSpeed: 60,
          loop: false
        });
      });
  
      return { typingTarget };
    }
  }
  </script>
  
  <style scoped> 
  /* Any specific styles for the WelcomeHeader can go here */
  </style>
